enum LeaderMenteesPlanMode {
  DAY = 'DAY',
  WEEK = 'WEEK',
}

export default LeaderMenteesPlanMode